export default function AlpineMuliSelectAdd() {
  console.log('AlpineMuliSelectAdd is initialized');
  Alpine.data('alpineMuliSelectAdd', (options = {}) => ({
    // Default options
    options: {
      placeholder: 'Type to search or add new tags...',
      maxTags: null,
      allowCreate: true,
      minSearchLength: 0,
      ...options,
    },

    // Component state
    availableTags: [],
    selectedTags: [],
    search: '',
    filteredTags: [],
    showDropdown: false,
    highlightedIndex: -1,
    nextId: 1,

    // Initialize component
    init() {
      // Use availableTags from options
      this.availableTags = options.availableTags || [];

      // Set nextId to the maximum existing ID + 1
      this.nextId =
        this.availableTags.length > 0
          ? Math.max(...this.availableTags.map((t) => t.id), 0) + 1
          : 1;

      // Initialize selected tags from options
      if (options.selectedTags && options.selectedTags.length > 0) {
        this.selectedTags = [...options.selectedTags];
      }

      this.filteredTags = this.availableTags.slice();

      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!this.$refs.tagSelectorContainer.contains(e.target)) {
          this.showDropdown = false;
        }
      });
    },

    // Filter available tags based on search
    filterTags() {
      const query = this.search.toLowerCase().trim();

      if (!query || query.length < this.options.minSearchLength) {
        this.filteredTags = this.availableTags.filter(
          (tag) => !this.isTagSelected(tag),
        );
      } else {
        this.filteredTags = this.availableTags.filter(
          (tag) =>
            tag.name.toLowerCase().includes(query) && !this.isTagSelected(tag),
        );
      }

      this.showDropdown = true;
      this.highlightedIndex = -1;
    },

    // Select a tag
    selectTag(tag) {
      if (this.isTagSelected(tag) || this.isMaxTagsReached) {
        return;
      }

      this.selectedTags.push(tag);
      this.search = '';
      this.filterTags();
      this.showDropdown = false;
      this.highlightedIndex = -1;
    },

    // Create and select a new tag
    createAndSelectTag(name) {
      if (!name || !this.options.allowCreate || this.isMaxTagsReached) {
        return;
      }

      const newTag = {
        id: this.nextId++,
        name: name.trim(),
        count: 0,
      };

      this.availableTags.push(newTag);
      this.selectTag(newTag);
    },

    // Remove a selected tag
    removeTag(tagToRemove) {
      this.selectedTags = this.selectedTags.filter(
        (tag) => tag.id !== tagToRemove.id,
      );
      this.filterTags();
    },

    // Check if a tag is already selected
    isTagSelected(tag) {
      return this.selectedTags.some((selected) => selected.id === tag.id);
    },

    // Handle Enter key
    handleEnter() {
      if (this.highlightedIndex >= 0) {
        if (this.highlightedIndex < this.filteredTags.length) {
          this.selectTag(this.filteredTags[this.highlightedIndex]);
        } else if (this.canCreateNew) {
          this.createAndSelectTag(this.search.trim());
        }
      } else if (this.search.trim() && this.canCreateNew) {
        this.createAndSelectTag(this.search.trim());
      }
    },

    // Navigate dropdown with arrow keys
    navigateDown() {
      const maxIndex = this.filteredTags.length + (this.canCreateNew ? 0 : -1);
      this.highlightedIndex = Math.min(this.highlightedIndex + 1, maxIndex);
    },

    navigateUp() {
      this.highlightedIndex = Math.max(this.highlightedIndex - 1, -1);
    },

    // Close dropdown
    closeDropdown() {
      this.showDropdown = false;
      this.highlightedIndex = -1;
    },

    // Computed properties
    get exactMatch() {
      return this.filteredTags.some(
        (tag) => tag.name.toLowerCase() === this.search.toLowerCase().trim(),
      );
    },

    get canCreateNew() {
      return (
        this.search.trim() &&
        !this.exactMatch &&
        this.options.allowCreate &&
        !this.isMaxTagsReached
      );
    },

    get isMaxTagsReached() {
      return (
        this.options.maxTags && this.selectedTags.length >= this.options.maxTags
      );
    },

    get selectedTagIds() {
      return this.selectedTags.map((tag) => tag.id).join(',');
    },
  }));
}
